import { render, staticRenderFns } from "./PoolContributionDetailsV2.vue?vue&type=template&id=63a11c20"
import script from "./PoolContributionDetailsV2.vue?vue&type=script&lang=js"
export * from "./PoolContributionDetailsV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports